import React from "react";
import { Event } from "../../models/Event";

interface EventProps {
  event: Event;
}

export const EventUI: React.FC<EventProps> = ({ event }) => {
  const newTemplate = (
    <div className={"col-md-4 case-item"} id={event.iID}>
      <div className="case-card card  h-100">
        <a href={event.link}>
          <img
            src={event.pictures.threeTwo}
            className={"card-img-top case-img"}
            alt={event.title}
          />
        </a>
        <div className={"case-card card-body"}>
          <a href={event.link} className={"event-link-cta"}>
            <h5 className={"card-title"}>{event.title}</h5>
            <p className={"event card-text"}>{event.teaser}</p>
          </a>
        </div>
        <div className={"case-card card-footer border-top-0"}>
          <p className={"card-text"}>
            <small className={"text-body-secondary"}>
              <i className={"fa-regular fa-calendar-days"}></i>
              {" "}
              {/* show start time if  */}
              { event.startDate.toLocaleDateString() === event.EndDate.toLocaleDateString() ? (
                event.starteDateLocalString.toLocaleDateString("da-DK", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                }) + " kl. " + event.formattedStartTime + " - " + event.formattedEndTime  
            ) :(
              "fra " +
              event.startDate.toLocaleDateString("da-DK", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              }) + " kl. " + event.formattedStartTime
            )}
            </small>
            {// if end date is not the same as start date, show end date}
            event.startDate.toLocaleDateString() !== event.EndDate.toLocaleDateString() && (
              <>
              <br />
              <small className={"text-body-secondary"}>
              <i style={{visibility:"hidden"}} className={"fa-regular fa-calendar-days"}></i>
              {" til "}   
                {
                  event.EndDate.toLocaleDateString("da-DK", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
              </small>
              <small className={"text-body-secondary text-center"}>
               
                {" kl. " +event.formattedEndTime}
              </small>
              </>
            )}
          </p>
          <p className={"card-text"}>
            <small className={"text-body-secondary"}>
              <i className={"fa-solid fa-location-dot"}></i>
              {" " + event.place}
            </small>
          </p>
        </div>
      </div>
    </div>
  );
  return newTemplate;
};

export default EventUI;
